import Component from 'flarum/common/Component';

/**
 * One faded line under a post; tap to see the whole signature.
 * Posts skip redraws unless the post itself changes, so the toggle flips the class directly.
 */
export default class Signature extends Component {
  view() {
    return m("div", {
      className: "GtSignature",
      onclick: e => {
        if (!e.target.closest('a')) e.currentTarget.classList.toggle('GtSignature--open');
      }
    }, m.trust(this.attrs.html));
  }
}
flarum.reg.add('noriods-ask', 'forum/components/Signature', Signature);